module.exports = __webpack_public_path__ + "img/model4.614ae9b6.png";